export const GET_ALL_USERS = "GET_ALL_USERS"
export const SEARCH_USERS = "SEARCH_USERS"
export const GET_USER = "GET_USER"
export const UPDATE_USER = "UPDATE_USER"
export const ADD_USER = "ADD_USER"
export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_PICTURE = "DELETE_USER_PICTURE"
